module.exports = __webpack_public_path__ + "static/media/Book1.06be6b16.xlsx";